import { useRef, useState } from 'react';
import { Camera, Loader2 } from 'lucide-react';
import api from '../lib/api';
import { resizeImage } from '../lib/imageResize';
import { toast } from '../hooks/use-toast';

// Botão "Ler VIN pela câmera": tira/escolhe foto → OCR no backend → devolve VIN + dados decodificados (NHTSA).
export const VinScanButton = ({ onResult, className = '', testid = 'vin-scan-btn', label = 'Foto' }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const img = await resizeImage(file);
      const fd = new FormData();
      fd.append('file', img, img.name || 'vin.jpg');
      const { data } = await api.post('/vin/scan', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 90000 });
      const d = data.decoded || {};
      const desc = [d.ano, d.marca, d.modelo, d.trim].filter(Boolean).join(' ');
      onResult(data);
      toast({
        title: data.valid ? `VIN lido: ${data.vin}` : `VIN lido (confira): ${data.vin}`,
        description: desc || (data.valid ? 'VIN válido — NHTSA não retornou dados.' : 'Dígito verificador não bateu — confira os caracteres.'),
      });
    } catch (e) {
      toast({ title: 'Não consegui ler o VIN', description: e.response?.data?.detail || 'Tente uma foto mais nítida, de frente e com boa luz.' });
    } finally { setBusy(false); }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden"
        onChange={(e) => { pick(e.target.files?.[0]); e.target.value = ''; }} />
      <button type="button" data-testid={testid} onClick={() => ref.current?.click()} disabled={busy} title="Ler VIN por foto (etiqueta da porta, para-brisa ou documento)"
        className={`inline-flex items-center justify-center gap-1.5 rounded-lg border border-border bg-muted/50 hover:bg-muted/80 text-sm font-semibold px-3 transition-colors disabled:opacity-60 whitespace-nowrap ${className}`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Camera className="w-3.5 h-3.5" />} {busy ? 'Lendo...' : label}
      </button>
    </>
  );
};
